<script setup>

import Footer from "@/components/Footer.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import {onMounted, onUnmounted} from "vue";
import EmailForm from "@/components/EmailForm.vue";
import {useHead} from "@vueuse/head";
import {useI18n} from "@/i18n";

const {t} = useI18n()

onMounted(() => {
  const scripts = [
    '/js/core.min.js',
    '/js/script.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
  window.addEventListener('popstate', handleBrowserNavigation)
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

onUnmounted(() => {
  window.removeEventListener('popstate', handleBrowserNavigation)
})

function handleBrowserNavigation() {
  window.location.reload()
}

</script>

<template>
  <div class="page">
    <HomeHeader/>

    <!-- Breadcrumbs -->
    <section class="bg-gray-7">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title" style="color: #0d0a0a">{{ t('page.contacts') }}</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <div class="box-transform" style="background-image: url(/images/bg-services.jpg);"></div>
      </div>
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">{{ t('common.home') }}</a></li>
          <li class="active">{{ t('page.contacts') }}</li>
        </ul>
      </div>
    </section>
    <!-- True professionals-->
    <section class="section section-xl bg-default text-center">
      <div class="container">
        <h6 class="subtitle-classic wow fadeInRight">{{ t('home.professional') }}</h6>
        <h2 class="title-classic oh-desktop"><span class="d-inline-block wow slideInUp">{{ t('home.team') }}</span></h2>
        <div class="owl-carousel owl-style-6 dots-style-2" data-items="1" data-sm-items="2" data-lg-items="3"
             data-margin="30" data-autoplay="true" data-dots="true" data-animation-in="fadeIn"
             data-animation-out="fadeOut">
          <!-- Team Ruth-->
          <article class="team-ruth text-sm-center text-md-start">
            <div class="team-ruth-body">
              <div class="team-ruth-header">
                <p class="team-ruth-title">President &amp; CEO</p>
              </div>
              <div class="unit align-items-center flex-sm-column flex-md-row">
                <div class="unit-left"><a class="team-ruth-figure" href="#"><img src="/images/business_2.png"
                                                                                 alt=""
                                                                                 width="167" height="162"/></a></div>
                <div class="unit-body">
                  <h5 class="team-ruth-name"><a href="#">Ms.Ray Chan</a></h5><a class="team-ruth-link"
                                                                                href="mailto:ray.chan@tpa-prefabhouse.com">ray.chan@tpa-<br>prefabhouse.com</a>
                  <a class="team-ruth-link"
                     href="tel:#">+86-13929160928</a>
                </div>
              </div>
            </div>
          </article>
          <!-- Team Ruth-->
          <article class="team-ruth text-sm-center text-md-start">
            <div class="team-ruth-body">
              <div class="team-ruth-header">
                <p class="team-ruth-title">Vice President &amp; CFO</p>
              </div>
              <div class="unit align-items-center flex-sm-column flex-md-row">
                <div class="unit-left"><a class="team-ruth-figure" href="#"><img src="/images/business_1.png"
                                                                                 alt=""
                                                                                 width="167" height="162"/></a></div>
                <div class="unit-body">
                  <h5 class="team-ruth-name"><a href="#">Ms.Kary Huang</a></h5><a class="team-ruth-link"
                                                                                  href="mailto:kary.huang@tpa-prefabhouse.com">kary.huang@tpa-<br>prefabhouse.com</a>
                  <a class="team-ruth-link"
                     href="tel:#">+86-13929163028</a>
                </div>
              </div>
            </div>
          </article>
          <!-- Team Ruth-->
        </div>
      </div>
    </section>
    <!-- Contacts-->
    <section class="section section-lg bg-default text-md-start">
      <div class="container">
        <div class="row row-60 justify-content-center">
          <div class="col-lg-8">
            <h4 class="text-spacing-25 text-transform-none">{{ t('common.getInTouch') }}</h4>
            <EmailForm/>
          </div>
          <div class="col-lg-4">
            <div class="aside-contacts">
              <div class="row row-30">
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">Get social</p>
                  <ul class="list-inline contacts-social-list list-inline-sm">
                    <li><a class="icon mdi mdi-facebook" href="https://www.facebook.com/profile.php?id=100083074701518"></a></li>
                    <li><a class="icon mdi mdi-linkedin" href="https://www.linkedin.com/company/84045662/admin/"></a></li>
                    <li><a class="icon mdi mdi-youtube-play" href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"></a></li>
                  </ul>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">{{ t('form.phoneOptional') }}</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-phone"></span></div>
                    <div class="unit-body"><a class="phone" href="tel:+86-13929160928">+86-13929160928</a></div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">{{ t('footer.email') }}</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-email-outline"></span></div>
                    <div class="unit-body"><a class="mail" href="mailto:ray.chan@tpa-prefabhouse.com">ray.chan@tpa-prefabhouse.com</a></div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">Address</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-map-marker"></span></div>
                    <div class="unit-body"><a class="address" href="#">Factory building in Shiquanzhongqiao Development
                      Zone, Songgang, Shishan Town, Nanhai District, Foshan City;<br class="d-md-none">Gaotian Road,Mingcheng Town,Gaoming
                      District,Foshan, Guangdong,China</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer/>
  </div>
</template>

<style scoped lang="scss">

</style>
